import { apiCall } from '@routable/framework';
import { z } from 'zod';
const emptyResponseModel = z.object({});
export const predictiveCodingService = {
    start: (annotationId, partnershipId) => apiCall({
        method: 'post',
        url: 'predictive_coding/predictions/start/',
        body: {
            annotation_id: annotationId,
            partnership_id: partnershipId,
        },
        responseModel: emptyResponseModel,
    }),
};
